import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { NewsletterSection } from '../components/NewsletterSection';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
import { CheckCircle, Heart, Users, Briefcase, Mail, Phone, User } from 'lucide-react';
export function GetInvolvedPage() {
  const [activeForm, setActiveForm] = useState<'volunteer' | 'partner' | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [volunteerData, setVolunteerData] = useState({
    name: '',
    email: '',
    phone: '',
    skills: '',
    availability: '',
    message: ''
  });
  const [partnerData, setPartnerData] = useState({
    organization: '',
    contactName: '',
    email: '',
    phone: '',
    partnershipType: '',
    message: ''
  });
  const handleVolunteerSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setVolunteerData({
        name: '',
        email: '',
        phone: '',
        skills: '',
        availability: '',
        message: ''
      });
      setTimeout(() => {
        setIsSubmitted(false);
        setActiveForm(null);
      }, 5000);
    }, 1500);
  };
  const handlePartnerSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setPartnerData({
        organization: '',
        contactName: '',
        email: '',
        phone: '',
        partnershipType: '',
        message: ''
      });
      setTimeout(() => {
        setIsSubmitted(false);
        setActiveForm(null);
      }, 5000);
    }, 1500);
  };
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-600">
      <Header data-id="element-601" />
      <main className="w-full font-sans" data-id="element-602">
        <PageHeader title="Get Involved" subtitle="Join us in our mission to uplift lives and transform communities" badgeText="JOIN OUR CAUSE" bgColor="bg-gradient-to-r from-sfrr-blue to-sfrr-pink" data-id="element-603" />

        {/* Ways to Get Involved */}
        <section className="py-16 bg-white" data-id="element-604">
          <div className="container mx-auto px-4" data-id="element-605">
            <div className="text-center mb-12" data-id="element-606">
              <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-607">
                Ways to Support Our Mission
              </h2>
              <p className="max-w-2xl mx-auto text-charcoal/80" data-id="element-608">
                There are many ways you can contribute to our cause and help
                make a difference in the lives of those we serve.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-609">
              {/* Donate */}
              <div className="bg-warm-ivory rounded-lg p-6 shadow-soft text-center hover:shadow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-610">
                <div className="bg-sfrr-pink/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-611">
                  <Heart className="h-8 w-8 text-sfrr-pink" data-id="element-612" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-613">Donate</h3>
                <p className="text-charcoal/80 mb-4" data-id="element-614">
                  Your financial contribution helps us implement our programs
                  and reach more communities in need.
                </p>
                <Link to="/donate" data-id="element-615">
                  <Button variant="primary" size="sm" data-id="element-616">
                    Donate Now
                  </Button>
                </Link>
              </div>

              {/* Volunteer */}
              <div className="bg-warm-ivory rounded-lg p-6 shadow-soft text-center hover:shadow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-617">
                <div className="bg-sfrr-green/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-618">
                  <Users className="h-8 w-8 text-sfrr-green" data-id="element-619" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-620">
                  Volunteer
                </h3>
                <p className="text-charcoal/80 mb-4" data-id="element-621">
                  Contribute your time and skills to support our programs and
                  make a direct impact on communities.
                </p>
                <Button variant="secondary" size="sm" onClick={() => setActiveForm('volunteer')} data-id="element-622">
                  Register as Volunteer
                </Button>
              </div>

              {/* Partner with Us */}
              <div className="bg-warm-ivory rounded-lg p-6 shadow-soft text-center hover:shadow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-623">
                <div className="bg-sfrr-blue/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-624">
                  <Briefcase className="h-8 w-8 text-sfrr-blue" data-id="element-625" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-626">
                  Partner with Us
                </h3>
                <p className="text-charcoal/80 mb-4" data-id="element-627">
                  Collaborate with us as an organization to create greater
                  impact through strategic partnerships.
                </p>
                <Button variant="primary" size="sm" onClick={() => setActiveForm('partner')} data-id="element-628">
                  Become a Partner
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Volunteer Form Modal */}
        {activeForm === 'volunteer' && <section className="py-16 bg-warm-ivory" data-id="element-629">
            <div className="container mx-auto px-4" data-id="element-630">
              <div className="max-w-2xl mx-auto bg-white rounded-2xl p-8 shadow-2xl" data-id="element-631">
                {!isSubmitted ? <>
                    <div className="text-center mb-8" data-id="element-632">
                      <div className="w-16 h-16 bg-sfrr-green/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-633">
                        <Users className="w-8 h-8 text-sfrr-green" data-id="element-634" />
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-2" data-id="element-635">
                        Volunteer Registration
                      </h2>
                      <p className="text-gray-600" data-id="element-636">
                        Fill out the form below to join our volunteer team
                      </p>
                    </div>

                    <form onSubmit={handleVolunteerSubmit} className="space-y-6" data-id="element-637">
                      <div data-id="element-638">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-639">
                          <User className="inline w-4 h-4 mr-2" data-id="element-640" />
                          Full Name *
                        </label>
                        <input type="text" required value={volunteerData.name} onChange={e => setVolunteerData({
                    ...volunteerData,
                    name: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" placeholder="Enter your full name" data-id="element-641" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-642">
                        <div data-id="element-643">
                          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-644">
                            <Mail className="inline w-4 h-4 mr-2" data-id="element-645" />
                            Email Address *
                          </label>
                          <input type="email" required value={volunteerData.email} onChange={e => setVolunteerData({
                      ...volunteerData,
                      email: e.target.value
                    })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" placeholder="your@email.com" data-id="element-646" />
                        </div>

                        <div data-id="element-647">
                          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-648">
                            <Phone className="inline w-4 h-4 mr-2" data-id="element-649" />
                            Phone Number *
                          </label>
                          <input type="tel" required value={volunteerData.phone} onChange={e => setVolunteerData({
                      ...volunteerData,
                      phone: e.target.value
                    })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" placeholder="0803 330 4041" data-id="element-650" />
                        </div>
                      </div>

                      <div data-id="element-651">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-652">
                          Skills & Expertise *
                        </label>
                        <input type="text" required value={volunteerData.skills} onChange={e => setVolunteerData({
                    ...volunteerData,
                    skills: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" placeholder="e.g., Teaching, Healthcare, Agriculture" data-id="element-653" />
                      </div>

                      <div data-id="element-654">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-655">
                          Availability *
                        </label>
                        <select required value={volunteerData.availability} onChange={e => setVolunteerData({
                    ...volunteerData,
                    availability: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" data-id="element-656">
                          <option value="" data-id="element-657">Select availability</option>
                          <option value="weekends" data-id="element-658">Weekends Only</option>
                          <option value="weekdays" data-id="element-659">Weekdays Only</option>
                          <option value="flexible" data-id="element-660">Flexible</option>
                          <option value="full-time" data-id="element-661">Full Time</option>
                        </select>
                      </div>

                      <div data-id="element-662">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-663">
                          Additional Information
                        </label>
                        <textarea rows={4} value={volunteerData.message} onChange={e => setVolunteerData({
                    ...volunteerData,
                    message: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all resize-none" placeholder="Tell us why you want to volunteer..." data-id="element-664" />
                      </div>

                      <div className="flex gap-4" data-id="element-665">
                        <Button type="submit" variant="secondary" size="lg" fullWidth isLoading={isSubmitting} disabled={isSubmitting} data-id="element-666">
                          {isSubmitting ? 'Submitting...' : 'Submit Application'}
                        </Button>
                        <Button type="button" variant="outline" size="lg" onClick={() => setActiveForm(null)} data-id="element-667">
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </> : <div className="text-center py-8 animate-fadeIn" data-id="element-668">
                    <div className="w-16 h-16 bg-sfrr-green/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-669">
                      <CheckCircle className="w-10 h-10 text-sfrr-green" data-id="element-670" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-671">
                      Application Submitted!
                    </h2>
                    <p className="text-gray-600 mb-6" data-id="element-672">
                      Thank you for your interest in volunteering with us. We'll
                      review your application and get back to you soon.
                    </p>
                  </div>}
              </div>
            </div>
          </section>}

        {/* Partner Form Modal */}
        {activeForm === 'partner' && <section className="py-16 bg-warm-ivory" data-id="element-673">
            <div className="container mx-auto px-4" data-id="element-674">
              <div className="max-w-2xl mx-auto bg-white rounded-2xl p-8 shadow-2xl" data-id="element-675">
                {!isSubmitted ? <>
                    <div className="text-center mb-8" data-id="element-676">
                      <div className="w-16 h-16 bg-sfrr-blue/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-677">
                        <Briefcase className="w-8 h-8 text-sfrr-blue" data-id="element-678" />
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-2" data-id="element-679">
                        Partnership Inquiry
                      </h2>
                      <p className="text-gray-600" data-id="element-680">
                        Let's explore how we can work together
                      </p>
                    </div>

                    <form onSubmit={handlePartnerSubmit} className="space-y-6" data-id="element-681">
                      <div data-id="element-682">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-683">
                          Organization Name *
                        </label>
                        <input type="text" required value={partnerData.organization} onChange={e => setPartnerData({
                    ...partnerData,
                    organization: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" placeholder="Your organization name" data-id="element-684" />
                      </div>

                      <div data-id="element-685">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-686">
                          <User className="inline w-4 h-4 mr-2" data-id="element-687" />
                          Contact Person Name *
                        </label>
                        <input type="text" required value={partnerData.contactName} onChange={e => setPartnerData({
                    ...partnerData,
                    contactName: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" placeholder="Enter contact person name" data-id="element-688" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-689">
                        <div data-id="element-690">
                          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-691">
                            <Mail className="inline w-4 h-4 mr-2" data-id="element-692" />
                            Email Address *
                          </label>
                          <input type="email" required value={partnerData.email} onChange={e => setPartnerData({
                      ...partnerData,
                      email: e.target.value
                    })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" placeholder="contact@organization.com" data-id="element-693" />
                        </div>

                        <div data-id="element-694">
                          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-695">
                            <Phone className="inline w-4 h-4 mr-2" data-id="element-696" />
                            Phone Number *
                          </label>
                          <input type="tel" required value={partnerData.phone} onChange={e => setPartnerData({
                      ...partnerData,
                      phone: e.target.value
                    })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" placeholder="0803 330 4041" data-id="element-697" />
                        </div>
                      </div>

                      <div data-id="element-698">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-699">
                          Partnership Type *
                        </label>
                        <select required value={partnerData.partnershipType} onChange={e => setPartnerData({
                    ...partnerData,
                    partnershipType: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" data-id="element-700">
                          <option value="" data-id="element-701">Select partnership type</option>
                          <option value="funding" data-id="element-702">Funding Partner</option>
                          <option value="implementation" data-id="element-703">
                            Implementation Partner
                          </option>
                          <option value="technical" data-id="element-704">Technical Partner</option>
                          <option value="corporate" data-id="element-705">
                            Corporate Social Responsibility
                          </option>
                          <option value="other" data-id="element-706">Other</option>
                        </select>
                      </div>

                      <div data-id="element-707">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-708">
                          Tell Us About Your Interest *
                        </label>
                        <textarea rows={4} required value={partnerData.message} onChange={e => setPartnerData({
                    ...partnerData,
                    message: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all resize-none" placeholder="Describe your partnership proposal..." data-id="element-709" />
                      </div>

                      <div className="flex gap-4" data-id="element-710">
                        <Button type="submit" variant="primary" size="lg" fullWidth isLoading={isSubmitting} disabled={isSubmitting} data-id="element-711">
                          {isSubmitting ? 'Submitting...' : 'Submit Inquiry'}
                        </Button>
                        <Button type="button" variant="outline" size="lg" onClick={() => setActiveForm(null)} data-id="element-712">
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </> : <div className="text-center py-8 animate-fadeIn" data-id="element-713">
                    <div className="w-16 h-16 bg-sfrr-blue/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-714">
                      <CheckCircle className="w-10 h-10 text-sfrr-blue" data-id="element-715" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-716">
                      Inquiry Submitted!
                    </h2>
                    <p className="text-gray-600 mb-6" data-id="element-717">
                      Thank you for your interest in partnering with us. Our
                      team will review your proposal and contact you shortly.
                    </p>
                  </div>}
              </div>
            </div>
          </section>}

        <NewsletterSection data-id="element-718" />
      </main>
      <Footer data-id="element-719" />
    </div>;
}